import * as angular from "angular";
import { Filter } from "../../models/filter.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { FilterDataProvider } from "../../data-provider/filter.dp";

let AdminUsersComponent = {
    selector: "vcAdminUsers",
    templateUrl: "/angular/components/admin/admin-users.component.html",
    bindings: {},
    controller: class AdminUsersController {
        public filter: Filter;
        public navigationBarService: NavigationBarHelperService;

        constructor(
            NavigationBarHelperService: NavigationBarHelperService,
            FilterDataProvider: FilterDataProvider
        ) {
            this.navigationBarService = NavigationBarHelperService;
            // Same provider pair as the campaigns tab: the filter pane edits
            // FilterDataProvider.filter and Apply merges into appliedFilter,
            // which the users list watches.
            this.filter = FilterDataProvider.appliedFilter;
        }
    },
};

angular
    .module("admin")
    .component(AdminUsersComponent.selector, AdminUsersComponent);
